(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var accordionElement = document.querySelectorAll(".acc .acc-element");
  accordionElement.forEach(function (accordionTitle) {
    var accToggler = accordionTitle.querySelector(".acc-title"); // const subMenu = accordionTitle.querySelector(".acc-content");

    accToggler.addEventListener("click", function (event) {
      event.preventDefault();
      accordionTitle.classList.toggle("acc-active");
    });
  });
});

},{}],2:[function(require,module,exports){
"use strict";

require("./menu");

require("./swapelements");

require("./scrollbarwidth");

require("./acc");

require("./scrollto");

},{"./acc":1,"./menu":3,"./scrollbarwidth":4,"./scrollto":5,"./swapelements":6}],3:[function(require,module,exports){
"use strict";

function menuFix() {
  var scrolled = window.pageYOffset;
  var body = document.body;

  if (scrolled > 1) {
    body.classList.add('fixed-header');
  } else if (scrolled < 1) {
    body.classList.remove('fixed-header');
  }
}

function largeLogoScroll() {
  var szerokoscOkna = window.innerWidth;
  var momentPrzelaczania = 768;
  var urzadzenieMobilne = szerokoscOkna < momentPrzelaczania;

  if (!urzadzenieMobilne) {
    var largeLogo = document.querySelector('.svg-largelogo-dims.large-logo');
    var scrollTop = window.scrollY || window.pageYOffset;

    if (largeLogo) {
      var transform = 'translateY(' + scrollTop / 1.5 + 'px)';
      largeLogo.style.transform = transform;
      console.log('largeLogoScroll');
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  menuFix();
});
window.addEventListener('scroll', function () {
  menuFix();
  largeLogoScroll();
});
window.addEventListener('resize', function () {
  menuFix();
});
var menuToggle = document.querySelector("#menuToggle");
menuToggle.addEventListener("click", function () {
  var htmlElement = document.querySelector("html");
  htmlElement.classList.toggle("menu-otwarte");
});
document.addEventListener("DOMContentLoaded", function () {
  var menuItemsWithChildren = document.querySelectorAll("#navmenu .menu-item-has-children");
  var body = document.body;
  menuItemsWithChildren.forEach(function (menuItem) {
    var link = menuItem.querySelector("a");
    var subMenu = menuItem.querySelector("ul.sub-menu");
    link.addEventListener("click", function (event) {
      event.preventDefault();
      body.classList.toggle("open-submenu");
      menuItem.classList.toggle("open");
    });
  });
}); // document.addEventListener( 'wpcf7mailsent', function( event ) {
//   location = 'http://akbrainding.pl/dziekujemy/';
// }, false );

var navLinks = document.querySelectorAll('.folio-buttons .btn');
navLinks.forEach(function (navLink) {
  navLink.addEventListener('click', function () {
    var tabToggleValue = this.getAttribute('data-folio-tab');
    var tabPanes = document.querySelectorAll('.folio-section');
    tabPanes.forEach(function (tabPane) {
      tabPane.style.display = 'none';
    });
    navLinks.forEach(function (link) {
      link.classList.add('btn-disabled');
      link.classList.remove('btn-selected');
    });
    this.classList.remove('btn-disabled');
    this.classList.add('btn-selected');
    var selectedTabPanes = document.querySelectorAll('.folio-section[data-folio-section="' + tabToggleValue + '"]');
    selectedTabPanes.forEach(function (selectedTabPane) {
      selectedTabPane.style.display = 'block';
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var folioButtons = document.querySelector('.folio-buttons');

  if (folioButtons) {
    var firstButton = folioButtons.querySelector('.btn');

    if (firstButton) {
      firstButton.click();
    }
  }
});
var faqLinks = document.querySelectorAll('.faq-buttons .faq-category');
faqLinks.forEach(function (faqLink) {
  faqLink.addEventListener('click', function () {
    var tabToggleValue = this.getAttribute('data-faq-tab');
    var tabPanes = document.querySelectorAll('.faq-section');
    tabPanes.forEach(function (tabPane) {
      tabPane.style.display = 'none';
    });
    faqLinks.forEach(function (link) {
      link.classList.add('faq-unactive-tab');
      link.classList.remove('faq-active-tab');
    });
    this.classList.remove('faq-unactive-tab');
    this.classList.add('faq-active-tab');
    var selectedTabPanes = document.querySelectorAll('.faq-section[data-faq-section="' + tabToggleValue + '"]');
    selectedTabPanes.forEach(function (selectedTabPane) {
      selectedTabPane.style.display = 'block';
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var faqButtons = document.querySelector('.faq-buttons');

  if (faqButtons) {
    var firstFaqButton = faqButtons.querySelector('.faq-category');

    if (firstFaqButton) {
      firstFaqButton.click();
    }
  }
});

},{}],4:[function(require,module,exports){
"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function calculateScrollbarWidth() {
  var headerElement = document.querySelector("#header");

  if (window.innerWidth > 992) {
    document.documentElement.style.setProperty('--scrollbar-width', window.innerWidth - document.body.clientWidth + 'px');
  }

  document.documentElement.style.setProperty('--header-height', headerElement.clientHeight + 'px');
}

document.addEventListener('DOMContentLoaded', function () {
  calculateScrollbarWidth();
});
window.addEventListener('resize', function () {
  calculateScrollbarWidth();
});
document.addEventListener("DOMContentLoaded", function () {
  var bodyElement = document.body;
  var observer = new MutationObserver(checkForFixedHeaderClass);
  var topBarElement = document.querySelector("#topBar");
  var observerOptions = {
    attributes: true,
    attributeFilter: ['class']
  };
  observer.observe(bodyElement, observerOptions);

  function checkForFixedHeaderClass(mutationsList) {
    var _iterator = _createForOfIteratorHelper(mutationsList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var mutation = _step.value;

        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Sprawdź, czy klasa "fixed-header" została dodana do body
          if (bodyElement.classList.contains('fixed-header')) {
            document.documentElement.style.setProperty('--topbar-height', '0px');
          } else {
            document.documentElement.style.setProperty('--topbar-height', topBarElement.clientHeight + 'px');
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
});

},{}],5:[function(require,module,exports){
"use strict";

document.addEventListener('click', function (event) {
  var target = event.target;

  if (target.tagName === 'A' && target.getAttribute('href').startsWith('#')) {
    event.preventDefault();
    var id = target.getAttribute('href');
    var $id = document.querySelector(id);

    if (!$id) {
      return;
    }

    var headerHeight = document.querySelector('header').offsetHeight;
    var pos = $id.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({
      top: pos,
      behavior: 'smooth'
    });
  }
});
document.addEventListener('click', function (event) {
  var clickedElement = event.target.closest('.faq-category');

  if (clickedElement) {
    setTimeout(function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 500);
  }
});

},{}],6:[function(require,module,exports){
"use strict";

var szerokoscOkna = window.innerWidth;
var momentPrzelaczania = 768;
var urzadzenieMobilne = szerokoscOkna < momentPrzelaczania;

function swapChildren(obj1, obj2) {
  var temp = Array.from(obj2.children).map(function (child) {
    return child.cloneNode(true);
  });
  obj2.innerHTML = '';
  Array.from(obj1.children).forEach(function (child) {
    return obj2.appendChild(child.cloneNode(true));
  });
  Array.from(temp).forEach(function (child) {
    return obj1.appendChild(child);
  });
}

function swapElements() {
  if (urzadzenieMobilne) {
    document.querySelectorAll("*[id^='_desktop_']").forEach(function (el) {
      var element = document.getElementById(el.id.replace('_desktop_', '_mobile_'));

      if (element) {
        swapChildren(el, element);
      }
    });
  } else {
    document.querySelectorAll("*[id^='_mobile_']").forEach(function (el) {
      var element = document.getElementById(el.id.replace('_mobile_', '_desktop_'));

      if (element) {
        swapChildren(el, element);
      }
    });
  }
}

window.addEventListener('resize', function () {
  var _cw = szerokoscOkna;
  var _mw = momentPrzelaczania;
  var _w = window.innerWidth;

  var _toggle = _cw >= _mw && _w < _mw || _cw < _mw && _w >= _mw;

  szerokoscOkna = _w;
  urzadzenieMobilne = szerokoscOkna < momentPrzelaczania;

  if (_toggle) {
    swapElements();
  }
});
document.addEventListener('DOMContentLoaded', function () {
  if (urzadzenieMobilne) {
    swapElements();
  }
});

},{}]},{},[2]);
